import { Collapse as AntdCollapse, CollapseProps as AntdCollapseProps } from "antd";
import styled from "styled-components";
import color from "../../resource/color";

interface StyledCollapseProps extends AntdCollapseProps {
  iconPadding?: string;
  backgroundColor?: string;
  paddingContentSpecial?: string;
}

export const Collapse = styled(AntdCollapse)<StyledCollapseProps>`
  .ant-collapse-item {
    border-radius: 8px 8px 8px 8px !important;
  }

  .ant-collapse-item.ant-collapse-item-active {
    .ant-collapse-header {
      border-radius: 8px 8px 0 0 !important;
    }
  }

  .ant-collapse-header {
    background: ${({ backgroundColor }) => backgroundColor || `${color.background1}`} !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    border-radius: 8px 8px 8px 8px !important;
  }

  .ant-collapse-expand-icon {
    padding: ${({ iconPadding }) => iconPadding || "68px 16px"} !important;
  }

  .ant-collapse-content-box {
    padding: ${({ paddingContentSpecial }) => paddingContentSpecial || "16px"} !important;
  }
`;

// .ant-collapse-arrow {
//   right: 27px !important;
// }

export default Collapse;
